import { Button, Flex, Tooltip } from "@radix-ui/themes";
import { Cross1Icon } from "@radix-ui/react-icons";

import { GondolaSelect } from "./gondola-select";
import CameraDropdown from "./camera-dropdown";
import PlanogramToggle from "./planogram-toggle";
import { Gondola } from "@/shared/api";

interface AnnotationHeaderPlanogramProps {
  gondolaDropdownValue: Gondola | null;
  isGondolaDisabled: boolean;
  onGondolaChange: (value: Gondola | null) => void;
  onCameraSelect: (cameraId: string) => void;
  onClosePlanogramView: () => void;
}

const AnnotationHeaderPlanogram = ({
  gondolaDropdownValue,
  isGondolaDisabled,
  onGondolaChange,
  onCameraSelect,
  onClosePlanogramView,
}: AnnotationHeaderPlanogramProps) => {
  return (
    <Flex p="1" justify="end" gap="1" align="center">
      <PlanogramToggle />

      <GondolaSelect
        value={gondolaDropdownValue}
        disabled={isGondolaDisabled}
        onValueChange={onGondolaChange}
      />

      <CameraDropdown onCameraSelect={onCameraSelect} />

      <Tooltip content="Close planogram view">
        <Button
          size="1"
          color="gray"
          variant="outline"
          className="p-1"
          onClick={onClosePlanogramView}
        >
          <Cross1Icon />
        </Button>
      </Tooltip>
    </Flex>
  );
};

export default AnnotationHeaderPlanogram;
